export * from './designedStrip';
